/**
 * Ouvrir globalement la modale de choix d'offre pro (Agence / Investisseur).
 * La modale partagée (components/common/Modal/UpgradePlan.jsx) s'enregistre à
 * son montage. Tous les boutons « Changer d'offre / Upgrade plan » du front
 * appellent openUpgradeModal() au lieu d'une navigation directe.
 */
import { isApp } from "../native/platform";

let openHandler = null;

export const registerUpgradeModal = (handler) => {
  openHandler = handler;
  return () => {
    if (openHandler === handler) openHandler = null;
  };
};

export const openUpgradeModal = (arg) => {
  // Conformité Apple 3.1.3(f) : aucun achat d'abonnement dans l'app native.
  // Les abonnements se souscrivent uniquement sur le web.
  if (isApp()) return;
  // `arg` peut être :
  //  - un objet meta ({ action, message }) → contexte de la fonctionnalité bloquée ;
  //  - une fonction fallback (compat historique) si la modale n'est pas montée.
  const meta = typeof arg === "function" ? null : arg || null;
  const fallback = typeof arg === "function" ? arg : null;
  if (typeof openHandler === "function") {
    openHandler(meta);
  } else if (typeof fallback === "function") {
    fallback();
  }
};